<template>
    <div>
        <h1>
            Update Texting Preferences
        </h1>
        <div class="card">
            <div class="card-header">Your Texting Preferences</div>
            <div class="card-body">
                <b-form-group>
                    <b-form-radio-group
                            id="radio-slots"
                            v-model="selected"
                            :options="options"
                            name="texting-options"
                            stacked/>
                </b-form-group>

                <b-button variant="primary" @click="saveTextingOption">Save</b-button>
                <b-button variant="secondary" href="/home">Exit</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {toastService} from "@/mixins/toastService";

    export default {
        name: "TextingPreferences.vue",
        data() {
            return {
                selected: '',
                options: []
            }
        },
        mixins: [
            toastService
        ],
        created(){
            document.title = 'Update Texting Preferences';
            this.loadTextingOptions();
            this.loadUserCurrentOption();
        },
        methods:{
            loadTextingOptions(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/texting/getList`)
                    .then(response=>{
                        for(let option of response.data){
                            this.options.push({
                                value: option.code,
                                text: option.description
                            })
                        }
                    })
            },
            loadUserCurrentOption(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/texting/getCurrent`)
                    .then(response=>{
                        this.selected = response.data.code;
                    })
            },
            saveTextingOption(){
                if(this.selected!=='') {
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/profile/texting/update`, this.selected)
                        .then(response => {
                            toastService.showRootToast('Setting updated', 'Your texting preferences have been updated','success', this.$root)
                        })
                        .catch(error=>{
                            toastService.showRootToast('Setting update failed','There was an issue with updating your texting preferences','danger', this.$root)
                        })
                }

            },
        }
    }
</script>

<style scoped>

</style>